import React from 'react'
import {Jumbotron} from 'react-bootstrap';

export const Jumbotroni = () => {
    return (
        <div>
        <Jumbotron>
    <ul>
    <li><h5>We supplier Trailers parts: BPW, & Henred Freuhaf</h5></li>
    <li><h5>We supply accessories for Trucks : Pneumatics, electricals</h5></li>
    <li><h5>We supply stone Crusher  parts and accessories: conveyor belts, fasteners, bearings etc</h5></li>
  </ul>
  </Jumbotron>    
        </div>
    )
}

export default  Jumbotroni;